export enum RelationCluster {
  Team = 'team',
  Type = 'type',
  Tag = 'tag',
  None = 'none',
}
